import React from 'react';

// Components
import TiptapTextIndentControlTool from './TiptapTextIndentControlTool';

// Types
import { ToolbarToolProps } from '../../../config/toolDefinitions/toolbarToolTypes';

const TiptapUnindentTextTool = (props: ToolbarToolProps) => (
    <TiptapTextIndentControlTool command="liftListItem" iconName="toolbar-unindent" {...props} />
);

export default TiptapUnindentTextTool;
